import React from "react";
import { Link } from "react-router-dom";
import { Container } from "./style";
import MockPhone from "../../../components/MockPhone/index";
import { Button, message } from "antd";
import { useSelector } from "react-redux";
import { ShareAltOutlined, EditOutlined } from "@ant-design/icons";
import CoachPreview from "../../../components/CoachPreview/index";

export default function ProfileBuilder() {
  const userInfo = useSelector((state) => state.userInfo.userInfo);

  // Mock challenges data for preview
  const mockChallenges = [
    {
      _id: "1",
      title: "Fitness Transformation",
      description:
        "Transform your body and mind with this intensive 30-day fitness program.",
      numberOfDays: 30,
    },
    {
      _id: "2",
      title: "Healthy Eating Habits",
      description:
        "Learn to develop sustainable healthy eating habits over 30 days.",
      numberOfDays: 30,
    },
  ];

  const onShareProfile = () => {
    if (!userInfo.coach?._id) {
      message.error("Coach ID is missing");
      return;
    }
    // Build the share link URL
    const shareUrl = `${window.location.origin}/ShareCoach?coachId=${userInfo.coach._id}`;
    // Copy to clipboard
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => {
        message.success("Link copied to clipboard");
      })
      .catch((err) => {
        console.error("Failed to copy link:", err);
        message.error("Failed to copy link");
      });
  };

  return (
    <Container>
      <div className="profileBuilderLeftSide">
        <div className="page-title">Profile Builder</div>
        <div className="mockupHintParagraph">
          Please see your current coach profile mockup on the right.
        </div>
        <div className="flex-start">
          <Link to="/ProfileBuilder/Edit">
            <Button size="large" type="primary" icon={<EditOutlined />}>
              Edit my profile
            </Button>
          </Link>
          <Button
            size="large"
            className="ml-10"
            icon={<ShareAltOutlined />}
            onClick={onShareProfile}
          >
            Share my profile
          </Button>
        </div>
      </div>
      <div className="profileBuilderRightSide">
        <MockPhone title="About coach" showTabbar>
          <CoachPreview
            coachData={{
              name: userInfo.coach?.name,
              profile_image: userInfo.coach?.profile_image,
              socialLink: userInfo.coach?.socialLink,
              about: userInfo.coach?.about,
              subscriberCount: userInfo.user?.subscriberCount,
            }}
            challenges={mockChallenges}
          />
        </MockPhone>
      </div>
    </Container>
  );
}
